import axios from "axios";
import Cookies from "js-cookie";

export default async function APIService(is_post, url, data, is_second_url = false, params = null) {
    let API_URL = is_second_url === true ? process.env.REACT_APP_API_URL2 + url : process.env.REACT_APP_API_URL + url;
    const admin_session = localStorage.getItem('admin_session');

    const axiosConfig = {
        headers: {
            method: is_post ? "post" : "get",
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${admin_session}`,
        },
        timeout: 90000, // 1 min 30 seconds
    };

    if (params !== null) {
        axiosConfig.params = params;
    }

    if (is_post === true) {
        return await axios
            .post(API_URL, data, axiosConfig)
            .then(function (response) {
                return response.data;
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        localStorage.removeItem('admin_session');
                        localStorage.removeItem('refreshToken');
                        window.location = "/";
                    }
                    return error.response.data;
                } else if (error.code === 'ECONNABORTED') {
                    return { message: 'Request timed out', status_code: 504 }
                } else if (error.request) {
                    return { message: 'Network connection time out', status_code: 504 }
                }
            });
    } else {
        return await axios
            .get(API_URL, axiosConfig)
            .then(function (response) {
                return response.data;
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                        localStorage.removeItem('admin_session');
                        localStorage.removeItem('refreshToken');
                        window.location = "/";
                    }
                    return error.response.data;
                } else if (error.code === 'ECONNABORTED') {
                    return { message: 'Request timed out', status_code: 504 }
                } else if (error.request) {
                    return { message: 'Network connection time out', status_code: 504 }
                }
            });
    }
}
